import Buttons from './buttons';
import PaymentCoordinator from './PaymentCoordinator';
import PaymentMethods from './payment-methods';
import PaypalStandaloneSection from './PaypalStandaloneSection';
import Spreedly from './Spreedly';

export default {
  Buttons,
  PaymentCoordinator,
  PaymentMethods,
  PaypalStandaloneSection,
  Spreedly,
};
